import { VHeaders } from '@/models/pagedlistmodel';

export function getSectionHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'inspectionForms.addSectionGridHeaders.name'
      ) as string,
      align: 'left',
      sortable: true,
      value: 'name',
    },
    {
      text: vm.$parent.$t(
        'inspectionForms.addSectionGridHeaders.position'
      ) as string,
      align: 'left',
      sortable: true,
      value: 'columnPosition',
      filters: [
        (val) => {
          if (val === '1') {
            return vm.$parent.$t('inspectionForms.positions.left') as string;
          }
          if (val === '2') {
            return vm.$parent.$t('inspectionForms.positions.right') as string;
          }
        },
      ],
    },
    {
      text: vm.$parent.$t(
        'inspectionForms.addSectionGridHeaders.action'
      ) as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getquestionHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'inspectionForms.addQuestionGridHeaders.name'
      ) as string,
      align: 'left',
      sortable: false,
      value: 'text',
    },
    {
      text: vm.$parent.$t(
        'inspectionForms.addQuestionGridHeaders.action'
      ) as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}
export function getHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'inspectionForms.inspectionFormGridHeaders.name'
      ) as string,
      value: 'name',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t(
        'inspectionForms.inspectionFormGridHeaders.action'
      ) as string,
      sortable: false,
    },
  ];
}
